export const REQUEST_PATH = {
  MONOLITH_AUTH_TOKEN: '/users/sso',
  ANALYTICS_AUTH_TOKEN: `/users/scoped_sso`,
};

export type AnalyticsScopedSSOResponse = {
  token: string;
  endpoint: string;
  endpoints: { analytics: string; monolith: string };
};
